import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { contactFormTypes } from './contactConstants.js';
import { DonorContactForm } from './DonorContactForm.js';
import TeacherContactForm from './TeacherContactForm.js';

export const ContactUs = createReactClass({
    propTypes: {
        data: PropTypes.object.isRequired,
        callbacks: PropTypes.object.isRequired,
    },

    renderSignIn() {
        if (!this.props.data.loggedInUser) {
            return (
                <div className="sign-in">
                    <a href="javascript:void(0);" className ="js-signin" onClick={function (event) { toggleSignInOverlay(event, true); return false; }}>Sign in</a> if you already have an account.
                </div>
            );
        }
    },

    getContactForm() {
        var result;
        switch (this.props.data.formType) {
        case contactFormTypes.DONOR:
            result = (

                <DonorContactForm
                    formData={this.props.data.formData}
                    formErrors={this.props.data.formErrors}
                    supportCategories={this.props.data.supportCategories}
                    tierSelectedSupportCategories={this.props.data.tierSelectedSupportCategories}
                    chosenSupportCategory={this.props.data.chosenSupportCategory}
                    loggedInUser={this.props.data.loggedInUser}
                    fieldsEnabledForEdits={this.props.data.fieldsEnabledForEdits}
                    donationInfo={this.props.data.donationInfo}
                    callbacks={this.props.callbacks}
                />
            );
            break;
        case contactFormTypes.TEACHER:
            result = (
                <TeacherContactForm
                    formData={this.props.data.formData}
                    formErrors={this.props.data.formErrors}
                    supportCategories={this.props.data.supportCategories}
                    tierSelectedSupportCategories={this.props.data.tierSelectedSupportCategories}
                    chosenSupportCategory={this.props.data.chosenSupportCategory}
                    projects={this.props.data.projects}
                    filteredProjects={this.props.data.filteredProjects}
                    loadingProjects={this.props.data.loadingProjects}
                    showAllProjects={this.props.data.showAllProjects}
                    loggedInUser={this.props.data.loggedInUser}
                    callbacks={this.props.callbacks}
                />
            );
            break;
        }
        return result;
    },

    render() {
        return (
            <div className="contentCol">
                <h1>Contact us</h1>

                <ul className="DCtabs">
                    <li>
                        <a className={this.props.data.formType === contactFormTypes.DONOR ? 'active' : ''} href={secureBaseURL + 'help/donor_contact_form.html'}>I'm not a teacher</a>
                    </li>
                    <li>
                        <a className={this.props.data.formType === contactFormTypes.TEACHER ? 'active' : ''} href={secureBaseURL + 'contact/contact_form.html'}>I'm a teacher</a>
                    </li>
                </ul>
                {this.renderSignIn()}
                {this.getContactForm()}
            </div>
        );
    },
});
